import { ActivatedRoute } from '@angular/router';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { Component } from "@angular/core";
import { List } from 'immutable';


@Component({
    selector: 'yt-osnov-za-pravo-na-go-update-container',
    templateUrl: './osnov-za-pravo-na-go-update-container.component.html',
    providers: [
      InlineContainerService
    ]
})
export class OsnovZaPravoNaGoUpdateContainer<T extends BaseEntity> extends BaseInlineContainer<T> {
  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService) {
super(inlineContainerService, activatedRoute, userService);
}

tempItems: List<T>

setItems(items) {
this.tempItems = items;
}
}
